// eslint-disable-next-line import/no-anonymous-default-export
export default {
    GexMap:

    [
        {
            featureType: 'administrative',
            elementType: 'all',
            stylers: [
              {
                visibility: 'simplified'
              },
              {
                gamma: 1.00
              },
              {
                saturation: 100
              }
            ]
          },
          {
            featureType: 'administrative.country',
            elementType: 'labels.text',
            stylers: [
              {
                color: '#a12d2d'
              }
            ]
          },
          {
            featureType: 'administrative.province',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'administrative.locality',
            elementType: 'labels',
            stylers: [
              {
                color: '#a62121'
              }
            ]
          },
          {
            featureType: 'administrative.neighborhood',
            elementType: 'labels',
            stylers: [
              {
                color: '#e57878'
              }
            ]
          },
          {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'simplified'
              },
              {
                lightness: 65
              },
              {
                saturation: -100
              },
              {
                hue: '#ff0000'
              }
            ]
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f6fff6'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'simplified'
              },
              {
                saturation: -100
              },
              {
                lightness: 80
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'poi.attraction',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'on'
              },
              {
                saturation: 100
              },
              {
                lightness: -13
              },
              {
                color: '#d6f2d5'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'simplified'
              },
              {
                color: '#dddddd'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road.highway.controlled_access',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'simplified'
              },
              {
                color: '#dddddd'
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'simplified'
              },
              {
                color: '#eeeeee'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#ba5858'
              },
              {
                saturation: -100
              }
            ]
          },
          {
            featureType: 'transit.station',
            elementType: 'all',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'transit.station',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#ba5858'
              },
              {
                visibility: 'simplified'
              }
            ]
          },
          {
            featureType: 'transit.station',
            elementType: 'labels.icon',
            stylers: [
              {
                hue: '#ff0036'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'simplified'
              },
              {
                color: '#a9d2d3'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#5884ba'
              }
            ]
          }
    ]
}